import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotifications } from 'app/application/application'
import { useApi } from 'app/common/application'

import { EventsGetRequest, EventsGetResponse, mapEvents } from '../types'

const useEvents = (audienceId: string) => {
  const { create } = useApi()
  const { createNotification } = useNotifications()
  const { t } = useTranslation('error')

  const getEvents = useCallback(
    () =>
      create<EventsGetRequest, EventsGetResponse>('/signals/events/query', {
        // all
        content: {
          audienceId,
          fromDate: '1970-01-01',
          toDate: new Date().toISOString(),
        },
        sorting: {
          by: 'timestamp',
          order: 'desc',
        },
      }).then((result) => {
        if (result.ok) {
          return mapEvents(result.val.data.events)
        } else {
          createNotification({
            message: result.val.message,
            title: t(`http.${result.val.code}`),
            type: 'error',
          })

          return []
        }
      }),

    [audienceId, create, createNotification, t],
  )

  return {
    getEvents,
  }
}

export default useEvents
